(function () {
  function parseJsonScript(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function readSelectedOptions(root) {
    const opts = {};
    root.querySelectorAll('fieldset[data-option-position]').forEach((fs) => {
      const pos = fs.dataset.optionPosition;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) opts['option' + pos] = checked.value;
    });
    return opts;
  }

  function findVariant(variants, opts) {
    return variants.find((v) => {
      for (let i = 1; i <= 3; i++) {
        const key = 'option' + i;
        if (opts[key] == null || opts[key] === '') continue;
        const variantVal = v[key] == null ? '' : String(v[key]);
        if (variantVal !== String(opts[key])) return false;
      }
      return true;
    });
  }

  function initCardInlineForm(root) {
    if (root.dataset.inlineInitialized === 'true') return;
    root.dataset.inlineInitialized = 'true';

    const variantsScript = root.querySelector('[data-card-variants-json]');
    if (!variantsScript) return;

    const variants = parseJsonScript(variantsScript);
    const priceHost = root.querySelector('[data-inline-price]');
    const variantInput = root.querySelector('[data-inline-variant-input]');
    const templatesRoot = root.querySelector('[data-variant-price-templates]');
    const cardWrapper = root.closest('.card-wrapper');
    const highlightedEl = cardWrapper?.querySelector('[data-card-highlighted-text]');
    const highlightedTemplatesRoot = cardWrapper?.querySelector('[data-variant-highlighted-text-templates]');
    const selectBtn = root.querySelector('[data-select-toggle]');
    const submitBtn = root.querySelector('[data-add-submit]');
    const picker = root.querySelector('[data-inline-picker]');

    if (!variantInput || !selectBtn || !submitBtn || !picker) return;

    function collapsePicker() {
      root.classList.remove('is-inline-open');
      selectBtn.classList.remove('hidden');
      selectBtn.setAttribute('aria-expanded', 'false');
      submitBtn.classList.add('hidden');
    }

    function applyVariant(variant) {
      if (!variant || !priceHost || !variantInput) return;

      variantInput.value = String(variant.id);
      variantInput.toggleAttribute('disabled', variant.available === false);

      const tpl = templatesRoot?.querySelector(`[data-variant-price-id="${variant.id}"]`);
      if (tpl) {
        priceHost.innerHTML = tpl.innerHTML;
      }

      const highlightedTpl = highlightedTemplatesRoot?.querySelector(
        `[data-variant-highlighted-id="${variant.id}"]`,
      );
      if (highlightedEl) {
        if (highlightedTpl?.dataset.hasContent === 'true') {
          highlightedEl.innerHTML = highlightedTpl.innerHTML;
          highlightedEl.hidden = false;
        } else {
          highlightedEl.innerHTML = '';
          highlightedEl.hidden = true;
        }
      }

      const span = submitBtn.querySelector('span');
      if (span) {
        if (variant.available === false) {
          submitBtn.disabled = true;
          span.textContent = window.variantStrings?.soldOut || 'Sold out';
        } else {
          submitBtn.disabled = false;
          span.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    }

    function syncVariantFromInputs() {
      const opts = readSelectedOptions(root);
      const v = findVariant(variants, opts);
      if (v) {
        applyVariant(v);
      }
    }

    root.addEventListener('change', (event) => {
      if (event.target.matches?.('input[type="radio"]')) {
        syncVariantFromInputs();
      }
    });

    function openPicker() {
      if (root.classList.contains('is-inline-open')) return;
      root.classList.add('is-inline-open');
      selectBtn.classList.add('hidden');
      selectBtn.setAttribute('aria-expanded', 'true');
      submitBtn.classList.remove('hidden');
      syncVariantFromInputs();
    }

    selectBtn.addEventListener('click', openPicker);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
        if (!payload || payload.source !== 'product-form' || payload.productVariantId == null) return;
        if (!root.classList.contains('is-inline-open')) return;
        const addedId = String(payload.productVariantId);
        const currentId = String(variantInput.value || '');
        if (addedId !== currentId) return;
        collapsePicker();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-card-inline-form]').forEach(initCardInlineForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  // Re-init after cart drawer swaps innerHTML (e.g. after add-to-cart re-render)
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
